module.exports = __webpack_public_path__ + "static/img/10.4d88b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/10.png
// module id = T4j/
// module chunks = 0